var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hover",
          rawName: "v-hover",
          value: { over: _vm.onHover, leave: _vm.onLeave },
          expression: "{over: onHover, leave: onLeave}"
        }
      ],
      staticClass: "tooltip-cursor"
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.isActive
        ? _c(
            "span",
            {
              ref: "tooltipMsg",
              staticClass: "tooltip-msg white-bkg b-1 br px-1 gray-60"
            },
            [_vm._v(_vm._s(_vm.message))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }